// removed by extract-text-webpack-plugin
module.exports = {"filterPrice":"qempo_RangeType_filterPrice-1s3RiJZ","rangeWrap":"qempo_RangeType_rangeWrap-1KX_zYo"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Filter/RangeType/RangeType.scss
// module id = 1593
// module chunks = 0